import { useCallback } from 'react'
import { performSignOut } from '../lib/signOut'
import { logAuthEvent } from '../lib/workos-token-utils'
import useAuth from '../models/useAuth'

export const useAuthState = () => {
  const { session, user, initialized } = useAuth()

  const signOut = useCallback(async () => {
    logAuthEvent('User initiated sign out')
    // Use shared sign-out function for consistent behavior
    await performSignOut()
  }, [])

  return {
    user,
    session,
    initialized,
    isAuthenticated: Boolean(user),
    signOut,
  }
}
